"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addInsuranceForEmiratesId = addInsuranceForEmiratesId;
exports.addNewInsurance = addNewInsurance;
exports.callTeleconsultService = callTeleconsultService;
exports.cancelAppointment = cancelAppointment;
exports.cdmServices = cdmServices;
exports.checkCDMAppointmentEligibility = checkCDMAppointmentEligibility;
exports.createAppointment = createAppointment;
exports.deleteInsurance = deleteInsurance;
exports.getAllInsurance = getAllInsurance;
exports.getAppointmentDetails = getAppointmentDetails;
exports.getAppointmentDetailsWithLatLong = getAppointmentDetailsWithLatLong;
exports.getAppointmentDetailsWithRxPreorder = getAppointmentDetailsWithRxPreorder;
exports.getAppointments = getAppointments;
exports.getAvailableSlots = getAvailableSlots;
exports.getAvailableSlotsCount = getAvailableSlotsCount;
exports.getCDMAppointmentDetails = getCDMAppointmentDetails;
exports.getFacilityAndInsuranceMapping = getFacilityAndInsuranceMapping;
exports.getInsuranceProviders = getInsuranceProviders;
exports.getPaymentOrderstatus = getPaymentOrderstatus;
exports.getPreBookingAppointmentCharges = getPreBookingAppointmentCharges;
exports.getPrescriptionById = getPrescriptionById;
exports.getShadowAppointmentDetails = getShadowAppointmentDetails;
exports.initiatePayment = initiatePayment;
exports.makeItDefaultInsurance = makeItDefaultInsurance;
exports.postShadowAppointmentDetails = postShadowAppointmentDetails;
exports.reasonCancelAppointment = reasonCancelAppointment;
exports.rebookAndRefundAppointment = rebookAndRefundAppointment;
exports.rescheduleAppointment = rescheduleAppointment;
exports.updateAppointmentStatus = updateAppointmentStatus;
exports.updateInsurance = updateInsurance;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */
// import { apiCall } from '../../../common/api/api';

function getAvailableSlots(requestParams, tokenData) {
  const {
    enableCache,
    kycVerified,
    ...rest
  } = requestParams;
  let finalQuery = (0, _utils.getSearchQuery)(rest);
  if (kycVerified !== undefined) {
    finalQuery = `${finalQuery}&kycVerified=${kycVerified}`;
  }
  const apiEndPoint = `${_ApiConst.TELE_SEARCH}/api/slot${finalQuery}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options,
    enableCache
  });
}
function getAvailableSlotsCount(requestParams, tokenData) {
  const {
    enableCache,
    kycVerified,
    ...rest
  } = requestParams;
  let finalQuery = (0, _utils.getSearchQuery)(rest);
  if (kycVerified !== undefined) {
    finalQuery = `${finalQuery}&kycVerified=${kycVerified}`;
  }
  const apiEndPoint = `${_ApiConst.TELE_SEARCH}/api/slot/availibility${finalQuery}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options,
    enableCache
  });
}
function createAppointment(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  let apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}`;
  if (_ApiConst.MOCK_API) {
    apiEndPoint = `${_ApiConst.MOCK_API_TELE_CONSULT_BASE_URL}bookAppointment.json`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function rebookAndRefundAppointment(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params,
    id
  } = data;
  let apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}/${id}`;
  if (_ApiConst.MOCK_API) {
    apiEndPoint = `${_ApiConst.MOCK_API_TELE_CONSULT_BASE_URL}bookAppointment.json`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function rescheduleAppointment(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}/${requestParams.data.params.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams.data.params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: requestParams.data.params });
}
function reasonCancelAppointment(tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.REASON_CANCEL_APPOINTMENT_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function cancelAppointment(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}/${requestParams.data.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams.data;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: requestParams.data });
}
function getAppointments(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  let apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}${queryString}`;
  if (_ApiConst.MOCK_API) {
    apiEndPoint = `${_ApiConst.MOCK_API_TELE_CONSULT_BASE_URL}upcomingAppointmentList.json?patient=622b6acf5d583321d4cc1341&flag=UPCOMING`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getAppointmentDetails(appointmentId, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}/${appointmentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getShadowAppointmentDetails(appointmentId, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.SHADOW_APPOINTMENT_URL}/${appointmentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function postShadowAppointmentDetails(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.SHADOW_APPOINTMENT_POST_URL}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function updateAppointmentStatus(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params,
    id,
    userId
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CONSULTATION_STATUS}/${id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getAppointmentDetailsWithLatLong(appointmentId, lat, long, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}?id=${appointmentId}&lat=${lat}&long=${long}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getAppointmentDetailsWithRxPreorder(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}/${requestParams === null || requestParams === void 0 ? void 0 : requestParams.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function initiatePayment(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.INITIATE_PAYMENT}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function getAllInsurance(requestParams, tokenData, enableCache = false) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_PATIENTS_INSURANCE}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options,
    enableCache
  });
}
function getInsuranceProviders(tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_INSURANCE_PROVIDERS}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function addNewInsurance(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_PATIENTS_INSURANCE}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: params, requestType: API_PARAMS.POST });
}
function addInsuranceForEmiratesId(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_INSURANCE_EMIRATES}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPaymentOrderstatus(requestParams, tokenData) {
  // eslint-disable-next-line camelcase
  const {
    order_ref_id,
    user_id
  } = requestParams.data;
  // eslint-disable-next-line camelcase
  const queryString = `/${order_ref_id}?userId=${user_id}`;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_PAYMENT_STATUS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callTeleconsultService(requestParams, tokenData) {
  const {
    appointmentId
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CALL_TELECONSULT_SERVICE}${appointmentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getPrescriptionById(id, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_PRESCRIPTION_URL}/${id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function makeItDefaultInsurance(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.MAKE_INSURANCE_DEFAULT}/${requestParams === null || requestParams === void 0 ? void 0 : requestParams.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: requestParams });
}
function getPreBookingAppointmentCharges(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_URL}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}

/* params: { id, data: data?.resource } */

function updateInsurance(params, tokenData) {
  const {
    id,
    data
  } = params;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.MAKE_INSURANCE_DEFAULT}?identifier=${id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = data;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, apiPostData: data, requestType: API_PARAMS.PUT });
}
/* params: { id } */
function deleteInsurance(params, tokenData) {
  const {
    id
  } = params;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.MAKE_INSURANCE_DEFAULT}/${id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: params, requestType: API_PARAMS.DELETE });
}
function getFacilityAndInsuranceMapping(params, tokenData) {
  const {
    userId,
    facilityIds,
    consultationType,
    doctorId
  } = params;
  const query = `?userId=${userId}&facilityId=${facilityIds === null || facilityIds === void 0 ? void 0 : facilityIds.join(',')}&consultationType=${consultationType}&doctorId=${doctorId}`;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_FACILITY_INSURANCE_MAPPING}${query}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function cdmServices(params, tokenData) {
  const {
    userId
  } = params;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/${userId}/${_ApiConst.CDM_DATA}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function checkCDMAppointmentEligibility(params, tokenData) {
  const {
    userId
  } = params;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/${userId}/checkCdmAppointmentEligibility`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCDMAppointmentDetails(params, tokenData) {
  const {
    userId
  } = params;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.APPOINTMENT_SERVICE_REST_URL}/${userId}/getCdmConsultationDetails`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}